import { useEffect, useState } from 'react';

import Avatar from '../../../assets/user/default-avatar.png';

const FullConversation = (props) => {
  const [sectionClass, updateSectionClass] = useState('full-conversation');

  const loadingAnimation = () => {
    setTimeout(function () {
      updateSectionClass('full-conversation full-conversation--active');
    }, 100);
  };

  useEffect(() => {
    loadingAnimation();
  }, [loadingAnimation]);

  return (
    <div className={sectionClass}>
      <div className="full-conversation__text">{props.conversation}</div>
      <img src={Avatar} alt="User icon" className="user-avatar" />
    </div>
  );
};

export default FullConversation;
